import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { createSelector, Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';

import { dayjs } from '../../../../core/dayjs/dayjs';

import { DispatchCalendarRemarksDialogActions } from './dispatch-calendar-remarks-dialog.actions';
import { dispatchCalendarRemarksDialogFeature } from './dispatch-calendar-remarks-dialog.feature';

const SEVERITY_OPTIONS = [
    { label: 'Info', value: 'info' },
    { label: 'Success', value: 'success' },
    { label: 'Warning', value: 'warn' },
    { label: 'Error', value: 'error' },
];

@Component({
    selector: 'app-dispatch-calendar-remarks-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, CalendarModule, DropdownModule, InputTextModule, TagModule, ButtonModule],
    templateUrl: './dispatch-calendar-remarks-dialog.component.html',
    styleUrl: './dispatch-calendar-remarks-dialog.component.scss',
})
export class DispatchCalendarRemarksDialogComponent {
    readonly severityOptions = SEVERITY_OPTIONS;
    readonly actions = DispatchCalendarRemarksDialogActions;

    viewModel$ = this.store.select(createSelector({
        pendingRemarks: dispatchCalendarRemarksDialogFeature.selectPendingRemarks,
        selectedDatesAsDate: dispatchCalendarRemarksDialogFeature.selectSelectedDatesAsDate,
        remarkText: dispatchCalendarRemarksDialogFeature.selectRemarkText,
        remarkSeverity: dispatchCalendarRemarksDialogFeature.selectRemarkSeverity,
        editingRemarkId: dispatchCalendarRemarksDialogFeature.selectEditingRemarkId,
        loadingViewDates: dispatchCalendarRemarksDialogFeature.selectLoadingViewDates,
        saving: dispatchCalendarRemarksDialogFeature.selectSaving,
        canAddRemark: createSelector(
            dispatchCalendarRemarksDialogFeature.selectSelectedDates,
            dispatchCalendarRemarksDialogFeature.selectRemarkText,
            (selectedDates, remarkText) => (selectedDates?.length ?? 0) > 0 && remarkText.trim().length > 0,
        ),
    }));

    constructor(public store: Store) {}

    /** p-calendar emits browser-local wall-time Dates; their Y-M-D is what
     *  the user picked, so format without timezone conversion. */
    onDatesSelected(dates: (Date | null)[] | null): void {
        const formatted = dates?.map((d) => d ? dayjs(d).format('YYYY-MM-DD') : null) ?? null;
        this.store.dispatch(this.actions.datesSelected({ dates: formatted }));
    }
}

